export enum RoleType {
  Administrator = 10,
  User = 1,
  Fullstandig = 7,
  UnknownRoleType = -1,
  NoAccess = -99
}
